import api from './api.js';

class User {
    constructor(){
        this.url_user        = 'Users';
        this.url_update_user = 'Users/Profile';
        this.url_create_user = 'Dealers';
        this.url_pw_forgot   = 'Account/ForgotPassword';
        this.url_pw_reset    = 'Account/ResetPassword';
        this.url_pw_update   = 'Account/ChangePassword';
    }

    create(dealerId, data){
        return api.post(`${this.url_create_user}/${dealerId}/SalesReps`, data);
    }

    update(data){
        return api.put(this.url_update_user, data);
    }

    // The User Type the profile would resolve to if saved. Read-only on the server.
    previewUserType(data){
        return api.post(`${this.url_update_user}/UserTypePreview`, data);
    }

    salesTax(userId){
        return api.get(`${this.url_user}/${userId}/SalesTax`);
    }

    get(){
        return api.get(`${this.url_user}/Profile`);
    }
    resendActivationEmail(id){
        return api.post(`${this.url_user}/${id}/ResendActivation`)
    }
    updatePassword(data){
        return api.post(this.url_pw_update, data);
    }

    triggerPasswordResetEmail(data){
        return api.post(this.url_pw_forgot, data);
    }

    resetPassword(data){
        return api.post(this.url_pw_reset, data);
    }
    hsusCoachPlus(data){
        return api.post(`${this.url_user}/HsusCoachPlus`, data)
    }
    lock(userId){
        return api.put(`${this.url_user}/${userId}/lock`);
    }

    unlock(userId){
        return api.put(`${this.url_user}/${userId}/unlock`);
    }

		getRedNewsIcon(){
			return api.get(`${this.url_user}/rednewsicon`);
		}
		turnRedNewsIconOff(){
			return api.put(`${this.url_user}/TurnRedNewsIconOff`);
		}

		acceptTos(){
			return api.post(`${this.url_user}/AcceptTos`);
		}

}

export default new User;
